// extracted by mini-css-extract-plugin
export var modal = "_u1-0";
export var table = "_u1-1";